import {
  CLEAR_DOCUMENT_VIEWER,
  CLOSE_ACTIVE_DEVIATION_MESSAGE,
  GET_ACTIVE_DEVIATION_SUCCESS,
  VIEW_DOCUMENT,
  VIEW_DOCUMENT_SUCCESS,
} from '../actions/DocumentViewerActions';

const initialState = {
  data: {},
  deviation: {},
  loading: false,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case VIEW_DOCUMENT:
      return {
        ...state,
        loading: true,
      };
    case VIEW_DOCUMENT_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        data: action.payload.data,
      };
    case GET_ACTIVE_DEVIATION_SUCCESS:
      return {
        ...state,
        error: null,
        loading: false,
        deviation: {
          ...action.payload.data,
          open: action.payload.data.HasActiveDeviations,
        },
      };
    case CLOSE_ACTIVE_DEVIATION_MESSAGE:
      return {
        ...state,
        deviation: {
          ...state.deviation,
          open: false,
        },
      };
    case CLEAR_DOCUMENT_VIEWER: {
      return initialState;
    }
    default:
      return state;
  }
};
